import { render, staticRenderFns } from "./AsideMenu.vue?vue&type=template&id=0c8e38a7&"
import script from "./AsideMenu.vue?vue&type=script&lang=js&"
export * from "./AsideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports